export default {
  title: "Errungenschaften",
  description: "Verfolgen Sie Ihren Hochzeitsplanungsfortschritt",
  stats: {
    pointsEarned: "Punkte verdient",
    completed: "Abgeschlossen",
    events: "Ereignisse",
    level: "Niveau",
    unlimited: "Unbegrenzt",
    limited: "Begrenzt",
    pro: "Pro",
    essential: "Essential",
    free: "Kostenlos"
  },
  categories: {
    all: "Alle",
    events: "Ereignisse",
    subscription: "Abonnement",
    engagement: "Engagement",
    social: "Social"
  },
  ui: {
    points: "Punkte",
    completedOn: "Abgeschlossen am",
    noAchievements: "Noch keine Errungenschaften in dieser Kategorie.",
    loading: "Laden...",
    error: "Fehler beim Laden der Errungenschaften"
  },
  rarity: {
    common: "Häufig",
    rare: "Selten",
    epic: "Episch",
    legendary: "Legendär"
  },
  achievements: {
    firstGuest: "Erster Gast",
    firstTask: "Erste Aufgabe",
    budgetSet: "Budget festgelegt",
    firstVendor: "Erster Anbieter",
    planningMaster: "Planungsmeister",
    organized: "Organisiert",
    budgetWise: "Budget-weise",
    socialite: "Gesellschaftsmensch",
    taskMaster: "Aufgabenmeister",
    timeKeeper: "Zeitwächter"
  },
  titles: {
    "Premier Pas": "Erster Schritt",
    "Organisateur Multi-événements": "Multi-Event-Organisator",
    "Maître des Célébrations": "Meister der Feiern",
    "Légende de l'Organisation": "Organisationslegende",
    "Cupide du Mariage": "Hochzeitsgierig",
    "Roi de la Fête": "Party-König",
    "Maître des Fiançailles": "Verlobungsmeister",
    "Spécialiste Baby Shower": "Baby-Shower-Spezialist",
    "Organisateur Spirituel": "Spiritueller Organisator",
    "Maître de Tous les Arts": "Meister aller Künste",
    "Utilisateur Fidèle": "Treuer Benutzer",
    "Expert Premium": "Premium-Experte",
    "Liberté Illimitée": "Unbegrenzte Freiheit",
    "Supporter de Wedora": "Wedora-Unterstützer",
    "Planificateur Assidu": "Fleißiger Planer",
    "Accro à l'Organisation": "Organisations-Süchtig",
    Perfectionniste: "Perfektionist",
    "Ambassadeur Wedora": "Wedora-Botschafter",
    "Ambassadeur WedBox": "WedBox-Botschafter",
    Mentor: "Mentor",
    "Organisateur débutant": "Anfänger-Organisator",
    "Organisateur confirmé": "Bestätigter Organisator",
    "Maître organisateur": "Meister-Organisator",
    "Premier invité": "Erster Gast",
    "Mariage intime": "Intime Hochzeit",
    "Grande célébration": "Große Feier",
    "Planificateur économe": "Sparsamer Planer",
    "Gestionnaire avisé": "Kluger Verwalter",
    "Expert financier": "Finanzexperte",
    "Chroniqueur débutant": "Anfänger-Chronist",
    "Maître du temps": "Zeitmeister",
    "Bienvenue !": "Willkommen!",
    "C'est parti !": "Los geht's!",
    "Supporter de WedBox": "WedBox-Unterstützer"
  },
  descriptions: {
    "Créez votre premier événement": "Erstellen Sie Ihr erstes Ereignis",
    "Gérez 3 événements différents": "Verwalten Sie 3 verschiedene Ereignisse",
    "Créez 5 événements différents": "Erstellen Sie 5 verschiedene Ereignisse",
    "Gérez 10 événements ou plus": "Verwalten Sie 10 oder mehr Ereignisse",
    "Organisez votre premier mariage": "Organisieren Sie Ihre erste Hochzeit",
    "Organisez 3 anniversaires": "Organisieren Sie 3 Geburtstage",
    "Organisez une cérémonie de fiançailles": "Organisieren Sie eine Verlobungszeremonie",
    "Organisez un baby shower": "Organisieren Sie eine Babyparty",
    "Organisez un baptême": "Organisieren Sie eine Taufe",
    "Organisez au moins un événement de chaque type": "Organisieren Sie mindestens ein Ereignis von jedem Typ",
    "Passez au plan Essential": "Wechseln Sie zum Essential-Plan",
    "Passez au plan Pro": "Wechseln Sie zum Pro-Plan",
    "Profitez des événements illimités du plan Pro": "Nutzen Sie die unbegrenzten Ereignisse des Pro-Plans",
    "Restez abonné pendant 3 mois": "Bleiben Sie 3 Monate lang abonniert",
    "Connectez-vous 7 jours consécutifs": "Melden Sie sich 7 Tage hintereinander an",
    "Connectez-vous 30 jours consécutifs": "Melden Sie sich 30 Tage hintereinander an",
    "Complétez 100% des tâches d'un événement": "Vollenden Sie 100% der Aufgaben eines Ereignisses",
    "Partagez votre expérience sur les réseaux sociaux": "Teilen Sie Ihre Erfahrung in sozialen Medien",
    "Aidez un autre utilisateur avec vos conseils": "Helfen Sie einem anderen Benutzer mit Ihren Ratschlägen",
    "Complétez 5 tâches": "Erledigen Sie 5 Aufgaben",
    "Complétez 15 tâches": "Erledigen Sie 15 Aufgaben",
    "Complétez 50 tâches": "Erledigen Sie 50 Aufgaben",
    "Ajoutez votre premier invité": "Fügen Sie Ihren ersten Gast hinzu",
    "Ajoutez 20 invités": "Fügen Sie 20 Gäste hinzu",
    "Ajoutez 100 invités": "Fügen Sie 100 Gäste hinzu",
    "Créez votre premier budget": "Erstellen Sie Ihr erstes Budget",
    "Ajoutez 5 dépenses": "Fügen Sie 5 Ausgaben hinzu",
    "Restez dans les limites de votre budget": "Bleiben Sie innerhalb Ihres Budgets",
    "Ajoutez votre premier événement au planning": "Fügen Sie Ihr erstes Ereignis zum Zeitplan hinzu",
    "Planifiez tous les événements importants": "Planen Sie alle wichtigen Ereignisse",
    "Créez votre compte Wedora": "Erstellen Sie Ihr Wedora-Konto",
    "Créez votre compte WedBox": "Erstellen Sie Ihr WedBox-Konto",
    "Complétez l'onboarding": "Vervollständigen Sie das Onboarding"
  },
  locked: "Gesperrt",
  unlocked: "Freigeschaltet",
  progress: "Fortschritt",
  earned: "Verdient",
  rewards: {
    points: "{{points}} Punkte",
    badge: "Abzeichen verdient",
    unlock: "Funktion freigeschaltet"
  },
  earnedPoints: "Verdiente Punkte",
  pointsCount: "{{earned}} / {{total}}",
  points: "{{count}} Punkt",
  points_one: "{{count}} Punkt",
  points_other: "{{count}} Punkte",
  completedAt: "Abgeschlossen am {{date}}",
  continue: "Fortfahren",
  empty: {
    title: "Keine Erfolge",
    description: "Noch keine Erfolge in dieser Kategorie."
  }
};
